import React from 'react';
import { useId } from 'react-id-generator';
import stringFormat from 'string-format';

interface ItemBoxesProps {
  className?: string;
  handleChange: (arg: string) => void;
  items: {[prop: string]: any}[];
  labelFormat: string;
  value?: string;
  valueFormat: string;
}

const ItemBoxes = ({className, handleChange, items, labelFormat, value, valueFormat}: ItemBoxesProps) => {
  const [ inputId ] = useId();

  if (items.length < 1) {
    return (
      <div>-</div>
    );
  }

  return (
    <div className={className}>
      {items.map(item => {
        const radioValue = stringFormat(valueFormat, item);
        const radioLabel = stringFormat(labelFormat, item);
        return (
          <React.Fragment key={radioValue}>
            <input
              checked={radioValue === value}
              id={`${inputId}-${radioValue}`}
              name={inputId}
              onChange={e => handleChange(e.target.value)}
              type="radio"
              value={radioValue}
            />
            <label htmlFor={`${inputId}-${radioValue}`}>{radioLabel}</label>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default ItemBoxes;
